module.exports = __webpack_public_path__ + "static/digital-asia-2a7a6b32855f3a8f38b2c3e7f7923fee.png";